<!--
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
-->

<script lang="ts">
  import { onDestroy } from 'svelte'
  import EmbeddedPDF from './EmbeddedPDF.svelte'
  import Loading from './Loading.svelte'

  export let src: string
  export let name: string
  export let fit: boolean = false
  export let css: string | undefined = undefined

  let iframeSrc: string | undefined

  async function loadFile(src: string): Promise<void> {
    if (iframeSrc !== undefined) {
      URL.revokeObjectURL(iframeSrc)
      iframeSrc = undefined
    }

    const response = await fetch(src)
    const blob = await response.blob()
    iframeSrc = URL.createObjectURL(blob)
  }

  $: void loadFile(src)

  onDestroy(() => {
    if (iframeSrc !== undefined) {
      URL.revokeObjectURL(iframeSrc)
    }
  })
</script>

{#if iframeSrc}
  <EmbeddedPDF src={iframeSrc} {name} {fit} {css} />
{:else}
  <Loading />
{/if}
